import React, { createContext, useContext, useReducer } from "react";

interface SideNav {
    id: string,
    name: string,
    icon: string,
    order: number,
    route: string,
    parentId: string,
    roleType: string
}

interface AuthState {
    isLogin: boolean;
    loginStatus: any;
    indicatorList: any[];
    userProfile: null | {
        id: string,
        email: string,
        name?: string,
        userName?: string,
        role: any,
        contact?: string,
        address?: string,
        country?: string,
        state?: string,
        city?: string,
        phone?: string,
        birthday?: string,
        gender?: string,
    },
    sideNav: SideNav[],
    isInitialized: boolean
}

const INITIAL_STATE: AuthState = {
    isLogin: false,
    loginStatus: null,
    userProfile: null,
    indicatorList: [],
    sideNav: [],
    isInitialized: false
};

export const SET_LOGIN_STATUS = "[AUTH] SET_LOGIN_STATUS";
export const SET_LOGIN_ERROR = "[AUTH] SET_LOGIN_ERROR";
export const SET_CURRENT_USER = "[AUTH] SET_CURRENT_USER";
export const CLEAR_CURRENT_USER = "[AUTH] CLEAR_CURRENT_USER";
export const UPDATE_INDICATOR = "[AUTH]UPDATE_INDICATOR";
export const SET_INITIALIZED = "[AUTH] SET_INITIALIZED";

const reducer = (state: AuthState, action: { type: string, payload: any }): AuthState => {
    const { type, payload } = action;
    switch (type) {
        case SET_CURRENT_USER:
            // Handle both login response and getCurrentUser response
            const userData = payload.currentUser || payload.user || payload;
            const { role, ...userProfile } = userData;
            return {
                ...state,
                userProfile: { ...userProfile, role: role?.name },
                sideNav: role?.roleSideNavigations || []
            }
        case SET_LOGIN_STATUS:
            return { ...state, isLogin: payload };
        case UPDATE_INDICATOR:
            return { ...state, indicatorList: payload};
        case CLEAR_CURRENT_USER:
            return { ...INITIAL_STATE, isInitialized: true };
        case SET_INITIALIZED:
            return { ...state, isInitialized: true };
        default:
            return state;
    }
};

const authContext = createContext<{ authState: AuthState; authDispatch: React.Dispatch<any>; }>
    ({ authState: INITIAL_STATE, authDispatch: () => null });

export const AuthProvider = ({ children }: any) => {
    const [authState, authDispatch] = useReducer(reducer, INITIAL_STATE);
    return (
        <authContext.Provider value={{ authState, authDispatch }} >
            {children}
        </authContext.Provider>
    );
}

export const useAuth = () => {
    return useContext(authContext);
}
